import * as React from "react";
import {withAppStores} from "../../../AppStores";
import {ModuleView} from "../abstract/ModuleView";
import {XyiconFeature, Permission} from "../../../generated/api/base";
import type {AppState} from "../../../data/state/AppState";
import type {IModel} from "../../../data/models/Model";

export interface BoundaryViewProps {
	readonly appState?: AppState;
}

@withAppStores("appState")
export class BoundaryView extends React.Component<BoundaryViewProps> {
	private canDelete = (selectedItems: IModel[]) => {
		const {actions} = this.props.appState;

		return selectedItems.every((item) => actions.getModuleTypePermission(item.typeId, item.ownFeature) >= Permission.Delete);
	};

	public override render() {
		return (
			<ModuleView
				feature={XyiconFeature.Boundary}
				className="XyiconView"
				actionBar={[
					{
						id: "import",
						title: "Update Boundaries with an Excel file",
						label: "Import",
					},
					{
						id: "delete",
						title: "Delete Boundary",
						label: "Delete",
						enabled: (selectedItems) => selectedItems.length > 0 && this.canDelete(selectedItems),
					},
				]}
			/>
		);
	}
}
